/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Image, Space, Dropdown, Menu } from "antd";
import { TableCell, TableRow } from "@mui/material";
import ElipsisIcon from "../../../../../assets/images/icon_actions/Elipsis.svg";
import { Link, NavLink } from "react-router-dom";
import customStyles from "../../../../../assets/styles/customStyles";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import clsx from "clsx";
import { supplierGroupHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { checkCRUDPermission, checkComponentPermission, getColumnWidth, idNamingConversion } from "../../../../../helpers/utilities";
import SearchText from '../../../../Shared/components/SearchText';
import ViewIcon from "../../../../../assets/images/icon_actions/View.svg";


export const SupplierGroupTable = (props) => {
    const { details, onRequestSort, sortOrder, sortBy, handleOpen, loadMore, loadMoreContent, loadMoreTask, roleManagement, onDelete, search, onHandle } = props;
    const classes = customStyles()

    return (
        <>
            <CustomInfiniteScroll
                loadMore={loadMore}
                loadMoreContent={loadMoreContent}
                heads={supplierGroupHead}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                sortOrder={sortOrder}
                sortBy={sortBy}
                loadMoreTask={() => loadMoreTask()}
                component={
                    <>
                        {
                            !loadMore || details === '' ? (
                                <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                                </TableRow>
                            ) : (
                                <React.Fragment>
                                    {
                                        details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={i}>
                                                <TableCell style={{ width: getColumnWidth(supplierGroupHead, 0) }}>
                                                    {
                                                        roleManagement !== '' && checkCRUDPermission('Supplier Group', 'view', 'Purchase') ?
                                                            <NavLink
                                                                id={idNamingConversion('View_' + data.id, 'supplierGroup', 'Link')}
                                                                className={clsx(classes.color, classes.wordBreak, classes.positionRelative, classes.disBlock, classes.bold)}
                                                                to={"#"}
                                                                onClick={() => onHandle(data, true, true)}>
                                                                <span style={{ width: getColumnWidth(supplierGroupHead, 0) }}>{data.name}</span>  </NavLink> : data.name
                                                    }

                                                </TableCell>
                                                <TableCell style={{ width: getColumnWidth(supplierGroupHead, 1) }}><span style={{ width: "100%", whiteSpace: "break-spaces", lineHeight: 1.5 }} className={classes.descEllipsis}>{data.description ? data.description : '---'}</span></TableCell>
                                                <TableCell>
                                                    <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Group', 'view', 'Purchase') &&
                                                            <NavLink id={idNamingConversion('View_' + data.id, 'supplierGroup', 'Icon')} to={"#"} onClick={() => onHandle(data, true, true)}>
                                                                <Image
                                                                    src={ViewIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Group', 'edit', 'Purchase') &&
                                                            <NavLink id={idNamingConversion('Edit_' + data.id, 'supplierGroup', 'Icon')} to={"#"} onClick={() => onHandle(data, false, true)}>
                                                                <Image
                                                                    src={EditIcon}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('Supplier Group', 'deletable', 'Purchase') &&
                                                            <NavLink to={"#"} id={idNamingConversion('Delete_' + data.id, 'supplierGroup', 'Icon')} onClick={() => onDelete(data)} >
                                                                <Image
                                                                    src={DeleteIcon}
                                                                    onClick={() => onDelete(data)}
                                                                    preview={false}
                                                                />
                                                            </NavLink>
                                                        }
                                                        <Dropdown
                                                            trigger={['click']}
                                                            placement={'bottomRight'}
                                                            overlay={
                                                                <Menu className={clsx(classes.groupMenu)}>
                                                                    <Menu.Item className={clsx(classes.accordionSubmenuArrow)}></Menu.Item>
                                                                    {
                                                                        roleManagement !== '' && checkComponentPermission('Supplier Group', 'Ellipsis Action', 'View Supplier') &&
                                                                        <Menu.Item><Link id={idNamingConversion('View Supplier_' + data.id, 'supplierGroup', 'Icon')} to={`/purchase/purchase-management/${data.id}/all-suppliers`}>View Supplier</Link></Menu.Item>
                                                                    }
                                                                </Menu>
                                                            }>
                                                            <Image
                                                                id={idNamingConversion('Elipsis_' + data.id, 'supplierGroup', 'Icon')}
                                                                src={ElipsisIcon}
                                                                preview={false}
                                                            />
                                                        </Dropdown>
                                                    </Space>
                                                </TableCell>
                                            </TableRow>
                                        )) : (
                                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                    {
                                                        search !== '' ? <SearchText /> : <><p className={clsx(classes.noResultsText, classes.textAlignCenter)}>{'Start creating groups for your Suppliers'}</p>
                                                            <div className={classes.margin20t}>
                                                                <NavLink
                                                                    style={{ display: "inline-block" }}
                                                                    to={`#`}
                                                                    onClick={() => handleOpen()}
                                                                    className={clsx(classes.modalBtn)}>Create Supplier Group
                                                                </NavLink>
                                                            </div></>
                                                    }

                                                </TableCell>
                                            </TableRow>
                                        )
                                    }
                                </React.Fragment>
                            )
                        }
                    </>
                }
            />
        </>
    )
}